module.exports = __webpack_public_path__ + "img/1.98aa9f61.jpg";